export const NAME = '@@Kick';
export const REDUCER_NAME = 'app';

export const DEFAULT_LOCATION = {
  lat: Number(DEFAULT_LAT),
  lng: Number(DEFAULT_LNG),
  country: DEFAULT_COUNTRY,
};
